import React from 'react'

export const Munich = ({ fill }) => (
<svg width="79.5022px" height="56.7037px" viewBox="0 0 79.5022 56.7037">
<g fill={fill}>
	<g>
		<path class="st0" d="M13.526,45.3553l-0.6518-0.69C5.5284,38.4029,4.5564,27.583,4.5187,27.1248
			C2.9811,13.5908,14.4936,5.5425,14.9842,5.2064c15.4127-9.2085,29.6731,6.3548,29.8152,6.5128
			c4.2217,5.1288,4.2385,9.7106,3.514,12.6571c-0.7859,3.1978-2.5788,5.171-2.6543,5.2536l-1.4723-1.3551l0.7362,0.6776
			l-0.7379-0.6758c0.2495-0.2744,6.0377-6.821-0.9022-15.2528c-0.0045-0.0035-3.3652-3.6973-8.4261-6.2726
			c-6.6514-3.3829-12.9746-3.3363-18.7943,0.1394c-0.0573,0.0417-10.9552,7.6899-9.553,20.0389
			c0.012,0.1341,0.9577,10.5329,7.7011,16.2465l0.0804,0.0755l0.6891,0.7291L13.526,45.3553z"/>
	</g>
	<g>
		<path class="st0" d="M67.3403,44.2301l-1.5487-1.2664l0.4511-0.5523c8.0242-8.2178,6.6576-17.3966,6.6425-17.488l-0.0125-0.1545
			C72.7796,10.5604,63.1693,6.3844,62.7599,6.2134c-13.277-5.3837-20.3159,3.8488-20.6089,4.2444l-1.6114-1.1855
			C40.62,9.1622,48.7574-1.6239,63.5183,4.3624c0.4636,0.1905,11.2185,4.7918,11.3543,20.3204
			c0.1519,1.0514,1.2406,10.4841-7.1398,19.0607L67.3403,44.2301z"/>
	</g>
	<g>
		<path class="st0" d="M59.1642,38.4854l-1.1846-1.6126c2.6188-1.9234,5.4348-8.0056,5.2873-13.6579
			c-0.0604-2.3271-0.6749-5.4574-3.2573-7.154c-6.1372-4.0343-11.8908,2.2196-12.1323,2.4882l-1.4892-1.336
			c2.4359-2.7209,8.6459-6.8147,14.7209-2.8244c2.6153,1.7188,4.053,4.7532,4.1578,8.7742
			C65.4169,28.9284,62.6223,35.9456,59.1642,38.4854z"/>
	</g>
	<g>
		<path class="st0" d="M19.4337,52.0537c-2.0651,0.0009-3.727-0.9315-4.5658-1.7237c-1.6274-1.7343-2.28-3.4341-1.983-5.0938
			c0.4702-2.6304,3.1952-4.0219,3.3106-4.0796c9.8266-5.2988,15.0699-10.7745,15.1219-10.8287l1.4532,1.3747
			c-0.2193,0.2318-5.4929,5.7509-15.6525,11.2283c-0.0431,0.0231-1.9786,1.0266-2.2654,2.6658
			c-0.1759,1.0026,0.3059,2.1206,1.4315,3.3221c0.071,0.0613,2.9061,2.6028,6.6234-0.1226l1.3347-0.9759
			c4.5712-3.3363,11.4791-8.3786,13.5501-11.2265l1.618,1.1766c-2.2556,3.1019-9.3163,8.2551-13.9887,11.6661l-1.3312,0.9724
			C22.4406,51.6195,20.843,52.0537,19.4337,52.0537z"/>
	</g>
	<g>
		<path class="st0" d="M61.2236,52.1478c-2.1118,0.0009-3.9571-0.9457-5.0165-1.8222c-1.3134-0.7593-15.506-9.0428-22.0672-16.0352
			c-6.0244-6.4204-2.074-14.1517-0.5745-16.5703c-3.1943-2.8209-7.7565-5.0702-12.4422-2.3276
			c-2.9225,1.7107-4.5876,5.1603-4.568,9.4642c0.0245,5.4356,2.6353,10.7194,6.3485,12.8489l-0.9946,1.7352
			c-4.3029-2.467-7.3271-8.4603-7.3547-14.5752c-0.0226-5.0365,2.0029-9.1183,5.5582-11.1994
			c8.6001-5.0374,16.588,3.6245,18.9395,7.3871c1.7796,2.8462,4.1746,5.3238,4.4943,5.6488
			c9.8226,7.9212,14.2964,10.3322,18.6229,12.6634c0.8525,0.46,1.7032,0.9183,2.5913,1.4155
			c2.0123,1.1269,3.173,2.5443,3.4491,4.2128c0.412,2.4847-1.3658,4.497-1.4413,4.5814
			C64.9374,51.488,62.9872,52.1478,61.2236,52.1478z M35.0258,19.1401c-1.4235,2.3706-4.3105,8.577,0.5732,13.7809
			c6.5328,6.9621,21.5326,15.6285,21.6835,15.7155l0.151,0.1057c0.1625,0.1385,4.1204,3.386,7.8679-0.5275l0,0
			c-0.0009,0,1.1926-1.3836,0.9324-2.9065c-0.1759-1.0336-1.0008-1.9696-2.45-2.7813c-0.8782-0.492-1.7201-0.9457-2.5637-1.3996
			c-4.4135-2.379-8.9771-4.838-18.9741-12.9031l-0.0791-0.0718c-0.1128-0.1128-2.7867-2.8-4.8109-6.0386
			C36.8498,21.3038,36.0501,20.2328,35.0258,19.1401z"/>
	</g>
	<g>
		<path class="st0" d="M40.3584,54.0553c-10.52,0-16.9441-3.3621-17.3335-3.5716l0.9471-1.7628
			c0.1337,0.0719,13.5971,7.0705,33.3789,0.4387l0.6358,1.8968C51.3211,53.2906,45.374,54.0553,40.3584,54.0553z"/>
	</g>
	<g>
		<path class="st0" d="M39.548,45.1546c-4.3029,0-7.4191-1.0994-7.6136-1.1695l0.6789-1.8817
			c0.0657,0.024,6.6536,2.3276,13.6442-0.0071l0.6341,1.8968C44.2871,44.8641,41.7606,45.1546,39.548,45.1546z"/>
	</g>
	<g>
		
			<rect x="17.577" y="8.6307" transform="matrix(0.7893 -0.614 0.614 0.7893 -2.1282 13.06)" class="st0" width="0.7768" height="2.0004"/>
	</g>
	<g>
		
			<rect x="22.9254" y="7.9467" transform="matrix(0.6688 -0.7434 0.7434 0.6688 1.6752 20.5705)" class="st0" width="2.0008" height="0.9168"/>
	</g>
	<g>
		<rect x="29.4445" y="6.4168" class="st0" width="0.9537" height="2.0007"/>
	</g>
	<g>
		<rect x="14.253" y="12.7094" class="st0" width="1.3015" height="2.0007"/>
	</g>
	<g>
		<rect x="30.8071" y="10.2318" class="st0" width="0.8853" height="2.0007"/>
	</g>
	<g>
		<rect x="54.5829" y="5.94" class="st0" width="1.1198" height="2.0007"/>
	</g>
	<g>
		
			<rect x="52.4298" y="9.6172" transform="matrix(0.5734 -0.8193 0.8193 0.5734 13.8456 47.8251)" class="st0" width="0.8315" height="2.001"/>
	</g>
	<g>
		
			<rect x="47.077" y="7.8486" transform="matrix(0.9239 -0.3825 0.3825 0.9239 0.2496 18.9536)" class="st0" width="1.4261" height="2.001"/>
	</g>
	<g>
		
			<rect x="57.0346" y="9.4408" transform="matrix(0.6827 -0.7307 0.7307 0.6827 11.1516 45.5599)" class="st0" width="2.0005" height="0.9977"/>
	</g>
	<g>
		
			<rect x="61.9285" y="8.7306" transform="matrix(0.3808 -0.9247 0.9247 0.3808 30.3146 63.9819)" class="st0" width="2.0006" height="1.2524"/>
	</g>
	<g>
		<rect x="49.2867" y="37.5193" class="st0" width="0.7655" height="1.9998"/>
	</g>
	<g>
		
			<rect x="51.7255" y="41.0186" transform="matrix(0.9583 -0.2857 0.2857 0.9583 -9.6405 16.791)" class="st0" width="1.9999" height="0.833"/>
	</g>
	<g>
		<rect x="58.3979" y="43.1485" class="st0" width="1.2636" height="1.9998"/>
	</g>
	<g>
		
			<rect x="43.9088" y="32.5042" transform="matrix(0.7434 -0.6689 0.6689 0.7434 -10.5993 38.5266)" class="st0" width="1.9997" height="1.1444"/>
	</g>
	<g>
		
			<rect x="42.2051" y="36.235" transform="matrix(0.7069 -0.7073 0.7073 0.7069 -13.3491 41.338)" class="st0" width="1.9994" height="1.0827"/>
	</g>
	<g>
		<rect x="29.4445" y="37.8593" class="st0" width="0.9537" height="1.9998"/>
	</g>
	<g>
		
			<rect x="26.485" y="41.823" transform="matrix(0.912 -0.4103 0.4103 0.912 -15.1902 14.8581)" class="st0" width="1.0803" height="2.0002"/>
	</g>
	<g>
		<rect x="20.7316" y="45.833" class="st0" width="2.0007" height="0.936"/>
	</g>
	<g>
		<rect x="22.1573" y="40.8361" class="st0" width="0.8503" height="1.9998"/>
	</g>
</g>
</svg>
)

